import React, { cloneElement, useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import AdCardControlsPanel from './ControlsPanel'

import { toggleIsSoundMuted } from '../../../../../modules/actions/ads'
import { adPreviewIsSoundMutedSelector } from '../../../../../modules/selectors/ads'

import { CAROUSEL_ITEMS } from '../../../../../forms/Facebook/AdForms/fields'
import { MEDIA_TYPE } from '../../../../../forms/ReusableFormFields/AdFileUpload/fields'

function AdPreviewSoundControlWrapper({ formikValues = {}, children, isSoundDisabled = true }) {
  const dispatch = useDispatch()

  const isSoundMuted = useSelector(adPreviewIsSoundMutedSelector)

  const showControlsPanel = useMemo(
    () =>
      formikValues[MEDIA_TYPE] === 'video' || formikValues[CAROUSEL_ITEMS]?.some(item => item[MEDIA_TYPE] === 'video'),
    [formikValues]
  )

  const toggleIsSoundMutedHandler = useCallback(() => {
    dispatch(toggleIsSoundMuted())
  }, [dispatch])

  return (
    <>
      {/* Currently one preview may appear on many steps at the same time, */}
      {/* so we use additional prop isSoundDisabled to disable sound for all previews */}
      {/* and pass isSoundDisabled={false} on active step */}
      {cloneElement(children, {
        isSoundMuted: isSoundMuted || isSoundDisabled
      })}
      {showControlsPanel && (
        <AdCardControlsPanel onMuteSoundToggle={toggleIsSoundMutedHandler} isSoundMuted={isSoundMuted} />
      )}
    </>
  )
}

AdPreviewSoundControlWrapper.propTypes = {
  formikValues: PropTypes.object,
  isSoundDisabled: PropTypes.bool
}

export default AdPreviewSoundControlWrapper
